module.exports = __webpack_public_path__ + "img/yiqing.55f21ef6.png";